export const CACHEABLE_FOOTER_PLACEHOLDER = '###STATIC_FOOTER###';
